export default __webpack_public_path__ + "static/media/22.b34a0e28.svg";